import AddressLabel from './AddressLabel';

export default AddressLabel;
